
// initial state
const state = {
  query: ''
}

// getters
const getters = {
  currentQuery: state => state.query
}

// actions
const actions = {

  search ({ commit }, val) {
    commit('doSearch', val)
  }

}

// mutations
const mutations = {

  doSearch (state, query) {
    if (query === state.query) return
    state.query = query
    // console.log('search:', query)
    // TODO: do a search in backend
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js